import React from 'react';
import { Formik, Field } from 'formik';
import { editOrder } from '../../../actions'
import { TextField, RaisedButton } from 'material-ui';
import Snackbar from 'material-ui/Snackbar';

const getBilling = (disable) => [{
  label: 'Billing First Name',
  name: 'billingName',
  disabled: disable
}, {
  label: 'Billing Last Name',
  name: 'billingLastName',
  disabled: disable
}, {
  label: 'Address Line 1',
  name: 'billingAddress1',
  disabled: disable
}, {
  label: 'Address Line 2',
  name: 'billingAddress2',
  disabled: disable
}, {
  label: 'City',
  name: 'billingCity',
  disabled: disable
}, {
  label: 'State',
  name: 'billingState',
  disabled: disable
}, {
  label: 'Zipcode',
  name: 'billingZip',
  disabled: disable
}, {
  label: 'Country',
  name: 'billingCountry',
  disabled: disable
},]

class BillingAddress extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }
  render() {
    const { styles, order, dispatch, disableView } = this.props
    const options = getBilling(disableView)
    const { billingName, billingLastName,billingAddress1, billingAddress2, billingCity, billingState, billingZip, billingCountry } = order
    const initialValues = {
      billingName: billingName || '',
      billingLastName: billingLastName || '',
      billingAddress1: billingAddress1 || '',
      billingAddress2: billingAddress2 || '',
      billingCity: billingCity || '',
      billingState: billingState || '',
      billingZip: billingZip || '',
      billingCountry: billingCountry || ''
    }
    const hideView = this.props.disableView ? 'none' : 'inline'
    return (
      <div>
        <h2>Billing Address</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            onSubmit={(values) => {
              const new_billing =
              {
                billing_address1: values.billingAddress1,
                billing_address2: values.billingAddress2,
                billing_city: values.billingCity,
                billing_state: values.billingState,
                billing_zip: values.billingZip,
                billing_country: values.billingCountry,
                billing_name: values.billingName,
                billing_last_name: values.billingLastName
              }
              dispatch(editOrder(order.id, new_billing))
                .then((res) => {
                  this.setState({ open: true })
                })
                .catch((err) => { console.log("ERR", err) })
            }}
            render={(props) => (
              <form onSubmit={props.handleSubmit}>
                  <div className="row">
                    {options.map(({ label, name, disabled }) => (
                      <div className="col-md-6 col-lg-4">
                        <Field name={name}>
                          {({ field, form }) => (
                            <div>
                              <TextField
                                {...field}
                                floatingLabelText={label}
                                floatingLabelStyle={styles.floatingLabelStyle}
                                floatingLabelFixed={true}
                                disabled={disabled}
                              />
                              {form.touched[field.name]}
                            </div>
                          )}
                        </Field>
                      </div>
                    ))}
                  </div>
                  <br /><br />
                  {!disableView 
                  ?<span style={{display: hideView}}>
                    <RaisedButton type='submit' primary tabIndex={-1}> Save </RaisedButton>
                    
                  </span>
                  :null
                  }
              </form>
            )}
          />
        </div>
        <Snackbar
          open={this.state.open}
          message={'Billing Field(s) Edited Successfully!'}
          autoHideDuration={4000}
        />
      </div>
    )
  }
}

export default BillingAddress;


// WEBPACK FOOTER //
// ./src/components/orders/Common/BillingAddress.js